import { CustomForm, SimpleDialog } from 'src/shared/components/index';
import { Box } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { CustomSellDialogProps } from './Interface/sellModal';
import { I18N, PAYMENT_METHOD } from 'src/shared/constants/constants';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material';
import { FormFieldType } from 'src/shared/components/form-field/service/formFieldInterface';
import { Asset } from 'src/modules/Asset/models';
import { useFormik } from 'formik';

const CustomSellModal: FC<CustomSellDialogProps> = (props) => {
  const { open, onClose, handleSellAssetReq, selectedAsset } =
    props;
  const { t } = useTranslation(I18N.DEFAULT);
  const theme = useTheme();
  const initialFormikValue = {
    id: '',
    amount: '',
    paymentMethod: PAYMENT_METHOD[1].id,
  };

  const [initialValues, setInitialValues] = useState({ ...initialFormikValue, code: '', id: null as number });
  useEffect(() => {
    if (selectedAsset) {
      setInitialValues({ ...initialFormikValue, id: selectedAsset.id, code: selectedAsset.code });
    }
  }, [selectedAsset]);

  const fields: FormFieldType[] = [
    {
      id: 'code',
      name: 'code',
      isDisabled: true,
      type: 'alphanumerics',
      label: t('car.reg-no'),
      col: 5,
    },

    {
      id: 'amount',
      name: 'amount',
      type: 'integer_only',
      label: t('sellprice'),
      validations: {
        maxLength: 50
      },

      col: 3,
    },
    {
      id: 'paymentMethod',
      name: 'paymentMethod',
      type: 'select',
      options: PAYMENT_METHOD,
      itemLabelKey: 'name',
      itemValueKey: 'id',
      label: t('booking.paymenttype'),
      // handleFieldChange: handleInputChange,
      col: 3,
    },
  ];

  const handleSellAssetReqAction = (submitedValues: Asset) => {
    handleSellAssetReq(submitedValues)
  }

  const handleClose = () => {
    onClose();
  }

  return (
    <>
      <SimpleDialog
        open={open}
        onClose={handleClose}
        model_title={
          <Box className="ml-20 mt-20">

            <CustomForm
              formFields={fields}
              enableReinitialize={true}
              initialValues={initialValues}
              submitBtnHandler={handleSellAssetReqAction}
              cancelBtnHandler={handleClose}
              resetOnSubmit={false}
            />
          </Box>
        }

      />
    </>
  );
};

export default CustomSellModal;
